import { render, staticRenderFns } from "./MoveableBlockEditor.v2.vue?vue&type=template&id=2fab5864&scoped=true&"
import script from "./MoveableBlockEditor.v2.vue?vue&type=script&lang=js&"
export * from "./MoveableBlockEditor.v2.vue?vue&type=script&lang=js&"
import style0 from "./MoveableBlockEditor.v2.vue?vue&type=style&index=0&id=2fab5864&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fab5864",
  null
  
)

export default component.exports